<template>
	<header :class="{ overlay }">
		<h1>Young Voice</h1>
		<div class="logo">
			<img src="images/logo.png" alt="logo" />
		</div>
	</header>
</template>

<script>
export default {
	data: () => ({
		overlay: false
	}),

	watch: {
		$route() {
			this.overlay = this.$route.name === 'Results' ? true : false
		}
	}
}
</script>

<style lang="scss" scoped>
header {
	position: fixed;
	display: flex;
	justify-content: center;
	width: 100%;
	padding-top: 20px;
	top: 0;

	&.overlay {
		z-index: 2;
		background: linear-gradient(0deg, rgba(3, 74, 188, 0) 0%, rgba(3, 74, 188, 1) 80%);
		height: 200px;
		pointer-events: none;
	}
}

img {
	width: 110px;
	height: auto;

	@include media('<=phone') {
		width: 70px;
	}
}

h1 {
	opacity: 0;
	pointer-events: none;
	position: absolute;
}
</style>
